export default {
  listNationalities: [],
  nationality: {
    ativo: true,
    id: 0,
    nome: '',
    sigla: '',
  },
}
